import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useCallback, useState } from "react";

export default function ModalSelectQtdSugestion({
    open,
    qtdValue,
    handleClose,
    onSubmit
}: ModalSelectQtdSugestionProps) {

    const [inputValue, setInputValue] = useState(`${qtdValue || ""}`)

    const handleInputChange = useCallback((value: string) => {
        const formatValue = value.replace(/[^0-9]/g, '');
        setInputValue(formatValue);
    }, []);

    const handleSubmit = useCallback(() => {
        onSubmit(Number(inputValue))
        handleClose()
    }, [onSubmit, handleClose, inputValue])

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Alterar quantidade de dias"}
            </DialogTitle>
            <DialogContent>
                <TextField
                    margin="normal"
                    value={Number(inputValue)}
                    id="outlined-basic"
                    label="Quantidade"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => handleInputChange(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    autoFocus
                    onClick={handleSubmit}
                    disabled={inputValue === ""}
                >
                    Alterar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface ModalSelectQtdSugestionProps {
    open: boolean,
    qtdValue: number,
    handleClose: () => void,
    onSubmit: (arg: any) => void
}